// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  endpoint: 'https://portal-api-dev.cicca.org.kh/api/v1',
  clientCode: '001',
  publicKey: '343430434343',
  authorizeToken: 'yGiDqkqzVOwB3j2g53IsckTZoFFMoZ3L75Qie2lRaXg=',
  donationSite: 'https://donation-dev.cicca.org.kh',
  eLearningSite: 'https://cicca.org.kh/en/course',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
